import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  exchangeSchoolYearPath,
  nextYearStudentsPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  UPDATE_STUDENT_SUCCESS_MESSAGE,
  DELETE_STUDENT_SUCCESS_MESSAGE,
  FETCH_CLASSES_SUCCESS_MESSAGE,
  FETCH_NEXT_CLASSES_SUCCESS_MESSAGE,
  fetchClasses,
  fetchNextClasses,
  IStudentParam,
  updateStudent,
  fetchStudent,
  deleteStudent,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import Toast from "../../../molecules/Toast";
import StudentForm from "../../../templates/manager/StudentForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default (props: { match: { params: { id: string } } }) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const id = parseInt(props.match.params.id, 10);
  const [fetched, setFetched] = React.useState({
    classes: false,
    next_classes: false,
  });
  const { currentYear, nextYear } = useCurrentYear();

  React.useEffect(() => {
    if (
      state.success_message === UPDATE_STUDENT_SUCCESS_MESSAGE ||
      state.success_message === DELETE_STUDENT_SUCCESS_MESSAGE
    ) {
      Toast.success(state.success_message);
      dispatch(clearSuccessMessage());
      history.push(nextYearStudentsPath);
    }
    if (state.success_message === FETCH_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, classes: true }));
      }, 100);
    }
    if (state.success_message === FETCH_NEXT_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, next_classes: true }));
      }, 100);
    }
  }, [history, dispatch, state.success_message]);

  useDidMountEffect(() => {
    if (state.error) {
      Toast.error(state.error);
    }
  }, [dispatch, state.error]);

  const updateStudentFunc = React.useCallback(
    (userManager: IStudentParam) => {
      dispatch(peep(updateStudent(userManager)));
    },
    [dispatch, peep],
  );

  const deleteStudentFunc = React.useCallback(
    (id: number) => {
      dispatch(peep(deleteStudent(id)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    dispatch(fetchNextClasses(currentYear + 1));
    dispatch(fetchStudent(id));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, id, currentYear]);

  const student = React.useMemo(() => {
    return state.next_year_students.find(t => t.id === id);
  }, [id, state.next_year_students]);

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
          {
            title: `${titles.nextYearStudents} (${nextYear}年度)`,
            to: nextYearStudentsPath,
          },
        ]}
        currentTitle={`${titles.editNextYearStudent} (${nextYear}年度)`}
      />
      {fetched.classes && fetched.next_classes && student && (
        <StudentForm
          title={`${titles.editNextYearStudent} (${nextYear}年度)`}
          calling={calling}
          error={state.error}
          student={student}
          classes={state.classes}
          next_classes={state.next_classes}
          school={state.manager.school!}
          isNextYear={true}
          upsertStudent={updateStudentFunc}
          deleteStudent={deleteStudentFunc}
          plans={state.plans}
        />
      )}
    </div>
  );
};
